import React from 'react'
import _ from 'lodash'
import styled from 'styled-components'
import NumberFormat from 'react-number-format'

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 50px;
`

const Item = styled.div`
  display: flex;
  padding-bottom: 10px;
  flex-basis: 0;
  flex-grow: 1;
  min-width: 280px;
`

const Box = styled.div`
  background-color: ${props => props.color};
  border-radius: ${props => props.theme.borderRadius.light};
  width: 20px;
  height: 20px;
  margin-right: 20px;
  flex-grow: 0;
  flex-shrink: 0;
`

const Text = styled.div`
`

const Percent = styled.div`
  color: ${props => props.theme.colors.grey4};
  padding-left: 5px;
`

export default ({ payload }) => (
  <Container>
    {_.map(_.orderBy(payload, ['payload.value'], ['desc']), ({ color, payload: { percent, label, value } }, index) => (
      <Item key={index}>
        <Box color={color} />
        <Text>
          {label} <NumberFormat
            value={value}
            displayType='text'
            thousandSeparator
            prefix='$'
          />
        </Text>
        <Percent>
          {_.round(percent * 100)}%
        </Percent>
      </Item>
    ))}
  </Container>
)
